module.exports = __webpack_public_path__ + "img/Group 14.cf1eabc.svg";